import React from 'react';

import moment from 'moment';

import { generateKey } from 'Helpers/misc';

export default function ApproversTable(props) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th>{$t('Approver')}</th>
                        <th>{$t('Date')}</th>
                        <th>{$t('Status')}</th>
                        <th>{$t('Comments')}</th>
                    </tr>
                </thead>
                {props.approvers && props.approvers.length > 0 && (
                    <tbody>
                        {props.approvers.map((approver) => {
                            return (
                                <tr key={generateKey()}>
                                    <td>{`${approver.first_name || ''} ${approver.last_name || ''}`.trim() || approver.label || approver.email || '-'}</td>
                                    <td>{approver.pivot.approved_at ? moment(approver.pivot.approved_at).format('DD/MM/YYYY') : '-'}</td>
                                    <td>
                                        {props.displayApprovalStatuses && props.displayApprovalStatuses[approver.pivot.status]
                                            ? props.displayApprovalStatuses[approver.pivot.status]
                                            : approver.pivot.status || props.status}
                                    </td>
                                    <td>{approver.pivot.comments || '-'}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                )}
            </table>
        </div>
    );
}
